/**
 * Generates a group of radio buttons and appends it to a specified container.
 *
 * @param {string} container_id - The ID of the container element where the radio buttons will be appended.
 * @param {Object} mapping - The mapping object containing keys and display texts for the radio buttons.
 */
export function gen_radio_btn_group(container_id, mapping) {
    const container = document.getElementById(container_id);
    const col = document.createElement("div");
    col.className = "col";

    const div = document.createElement("div");
    div.className = "bg-white rounded-4 py-2 p-5 d-flex justify-content-evenly"
    for (let key in mapping) {
        const item_div = document.createElement("div");
        item_div.className = "row";

        const radio_input = document.createElement("input");
        radio_input.className = "btn-check";
        radio_input.type = "radio";
        radio_input.id = `${container_id}_${key}`;
        radio_input.setAttribute("autocomplete", "off");
        radio_input.textContent = mapping[Object.keys(mapping)[0]];
        radio_input.name = `${container_id}_btn`;

        const radio_label = document.createElement("label");
        radio_label.className = "btn rounded-5 border-2 fw-bold";
        radio_label.setAttribute("for", radio_input.id);

        radio_label.textContent = mapping[key];
        item_div.appendChild(radio_input);
        item_div.appendChild(radio_label);
        div.appendChild(item_div);
    }
    col.appendChild(div);
    container.appendChild(col);
}

/**
 * Generates a set of radio tabs and appends it to a specified container.
 *
 * @param {string} container_id - The ID of the container element where the radio tabs will be appended.
 * @param {Object} mapping - The mapping object containing keys and display texts for the radio tabs.
 */
export function gen_radio_tabs(container_id, mapping) {
    const container = document.getElementById(container_id);
    container.className = "mt-2"

    const ul = document.createElement("ul");
    ul.className = "nav nav-tabs";
    ul.role = "tablist";

    for (let key in mapping) {
        const li = document.createElement("li");
        li.className = "nav-item";

        const btn = document.createElement("button");
        btn.className = "nav-link";
        btn.id = `${key}_tab`;
        btn.type = "button";
        btn.role = "tab";
        btn.setAttribute("data-bs-toggle", "tab");
        btn.setAttribute("data-i18n", key);
        btn.textContent = mapping[key];

        li.appendChild(btn);
        ul.appendChild(li);
    }
    container.appendChild(ul);
    $(container).localize();
}